<div class="no-results-message">
    <div class="main" trans>Trash is empty.</div>
    <div class="secondary" trans>There are no files or folders in your trash currently.</div>
    <mat-icon svgIcon="trash-custom" class="icon"></mat-icon>
</div>